var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "p-0 flex flex-col items-center justify-center border-blue-200 border-solid border rounded-lg md:grid md:grid-cols-4 md:content-center"
  }, [_c('div', {
    staticClass: "flex justify-center text-indigo-600 text-lg font-normal py-5 border-b border-blue-200 border-solid w-full px-5 md:col-span-1 md:px-10 md:border-b-0"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-3 border-blue-200 border-solid md:border-l"
  }, _vm._l(_vm.list, function (val, lib) {
    return _c('div', {
      key: lib,
      staticClass: "first:rounded-t-lg last:rounded-b-lg odd:bg-white text-gray-900 text-sm font-light bg-indigo-100 bg-opacity-50 py-5 md:py-0 md:h-20"
    }, [_c('div', {
      staticClass: "grid grid-cols-11 items-center justify-center md:h-20 w-full"
    }, [_c('p', {
      staticClass: "mx-5 flex flex-row gap-3 items-center",
      class: {
        'col-span-5': _vm.isLastestEvaluationVisible,
        'col-span-7': !_vm.isLastestEvaluationVisible
      }
    }, [_c('TextToSpeech', {
      attrs: {
        "speak": lib,
        "withBars": !_vm.$isMobile
      }
    }), _vm._v("\n              " + _vm._s(lib) + "\n          ")], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 flex justify-center"
    }, [_vm.visibilityValue1 ? _c('checkbox-indigo', {
      attrs: {
        "disabled": _vm.isDisabled || _vm.isDisabledValue1,
        "value": val[_vm.libKeys[0]]
      },
      on: {
        "input": function (newValue) {
          _vm.changeValue(1, {
            key: lib,
            value: newValue
          });
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _vm.isLastestEvaluationVisible ? _c('div', {
      staticClass: "col-span-2 flex justify-center"
    }, [_vm.visibilityLastEval && !_vm.lastestEvaluation ? _c('div', [_vm._v("\n              Pas d'évaluation récente\n            ")]) : _vm._e(), _vm._v(" "), _vm.visibilityLastEval && _vm.lastestEvaluation ? _c('checkbox-indigo', {
      attrs: {
        "disabled": true,
        "value": _vm.lastestEvaluation[lib].value
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 flex justify-center"
    }, [_vm.visibilityValue2 ? _c('checkbox-indigo', {
      attrs: {
        "disabled": _vm.isDisabled,
        "value": val[_vm.libKeys[1]]
      },
      on: {
        "input": function (newValue) {
          _vm.changeValue(2, {
            key: lib,
            value: newValue
          });
        }
      }
    }) : _vm._e()], 1)])]);
  }), 0)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }